<div class="bai-surface-card">

  <div class="bai-section-header">
    <span class="bai-section-title">Outcomes</span>
    <p-button
      icon="pi pi-plus"
      [text]="true"
      size="small"
      (onClick)="openAdd()"
      aria-label="Add outcome"
    />
  </div>

  <!-- Filter chips -->
  <div class="bai-actions-filter-row" role="group" aria-label="Filter outcomes">
    <bai-filter-chip-group
      [options]="allFilters"
      [selected]="activeFilter()"
      ariaLabel="Filter outcomes"
      (selectionChange)="setFilterSelection($event)"
    />
  </div>

  <div class="overflow-x-auto">
    @if (filteredOutcomes().length === 0) {
      <p class="text-sm text-gray-400 px-4 py-4">No outcomes recorded yet.</p>
    } @else {
      <table class="bai-actions-table bai-outcomes-table text-sm">
        <thead>
          <tr>
            <th baiColResize scope="col">Outcome</th>
            <th baiColResize scope="col">Tags</th>
            <th baiColResize scope="col">Source</th>
            <th baiColResize scope="col" class="bai-cell-nowrap">Date Achieved</th>
            <th baiColResize scope="col" class="bai-cell-nowrap">ATI Value</th>
            <th baiColResize scope="col" class="bai-cell-nowrap">ATI Basis</th>
            <th baiColResize scope="col" class="bai-cell-nowrap">Status</th>
            <th baiColResize scope="col" class="bai-cell-nowrap">Linked Action</th>
            <th baiColResize scope="col" class="bai-cell-nowrap">Time to Outcome</th>
            <th baiColResize scope="col" class="bai-cell-nowrap">Updated</th>
            <th scope="col" class="w-24 bai-cell-nowrap">More</th>
          </tr>
        </thead>
        <tbody>
          @for (row of filteredOutcomes(); track row.id) {
            <tr
              class="cursor-pointer hover:bg-gray-50"
              (click)="openDetails(row)"
            >
              <td class="bai-outcomes-table__desc" [title]="row.description">
                {{ row.description }}
              </td>
              <td>
                <div class="flex flex-wrap gap-1">
                  @for (tag of row.tags; track tag) {
                    <span class="bai-outcome-tag" [attr.aria-label]="'Tag: ' + tag">{{ tag }}</span>
                  }
                  @if (row.tags.length === 0) {
                    <span class="text-gray-400">—</span>
                  }
                </div>
              </td>
              <td>
                <p-tag
                  [value]="row.sourceType === 'ai' ? 'AI Agent' : 'Human'"
                  [severity]="row.sourceType === 'ai' ? 'info' : 'secondary'"
                  styleClass="text-xs"
                />
              </td>
              <td class="bai-cell-nowrap">{{ row.dateAchieved || '—' }}</td>
              <td class="bai-cell-nowrap">{{ formatAti(row.atiValue) }}</td>
              <td class="bai-cell-nowrap">{{ formatBasis(row.atiBasis) }}</td>
              <td class="bai-cell-nowrap">
                <p-tag
                  [value]="row.status === 'verified' ? 'Verified' : 'Unverified'"
                  [severity]="row.status === 'verified' ? 'success' : 'warn'"
                  styleClass="text-xs"
                />
              </td>
              <td class="bai-cell-nowrap">{{ row.linkedActionId || '—' }}</td>
              <td class="bai-cell-nowrap">
                {{ row.timeToOutcomeDays !== null ? row.timeToOutcomeDays + ' days' : '—' }}
              </td>
              <td class="bai-cell-nowrap">
                <span class="block">{{ row.updatedBy }}</span>
                <span class="text-xs text-gray-400">{{ row.updatedAt }}</span>
              </td>
              <td (click)="$event.stopPropagation(); $any($event.target).closest('[class*=__action]') && $any($event.currentTarget).removeAttribute('open')">
                <details class="bai-copilot-kebab" (click)="$event.stopPropagation(); $any($event.target).closest('[class*=__action]') && $any($event.currentTarget).removeAttribute('open')">
                  <summary class="bai-copilot-kebab__btn" aria-label="Outcome options">
                    <i class="pi pi-bars" aria-hidden="true"></i>
                  </summary>
                  <button
                    type="button"
                    class="bai-copilot-kebab__action"
                    (click)="addOutcomeToCopilot(row)"
                  >
                    Add to Copilot
                  </button>
                </details>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>

</div>
